import moment from 'moment';
import { Config } from './Config';
import axios from 'axios';
import { useLocation } from 'react-router-dom';

const swalError = (error) => {
  let errorMessage = '';

  for (const key in error?.data?.error) {
    errorMessage += `${error?.data?.error[key]}
<br>`;
  }

  if (errorMessage) {
  }
};

const swalUpdated = (data) => {
  return;
};

const ReactDatePickerTimeConverter = (time) => {
  if (time) {
    return moment(time).format('DD/MM/YYYY');
  } else {
    return '';
  }
};

export const decodeEntities = (htmlString) => {
  const textarea = document.createElement('textarea');
  textarea.innerHTML = htmlString;
  return textarea.value;
};

const timeFormatter = (props) => props && moment(props).format('DD-MM-YYYY ');

export function isValidEmail(email) {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailPattern.test(email);
}

export { swalError, swalUpdated, ReactDatePickerTimeConverter, timeFormatter };

export const countAndDecision = (items, text) => {
  const itemsCount = items.length;
  if (itemsCount === 0) {
    return <span>{text}</span>;
  } else {
    return items
      .slice(0, 2)
      .map((item, index) => {
        return <span key={index}>{item}</span>;
      })
      .concat(itemsCount > 2 ? <span> + {itemsCount - 2}</span> : '');
  }
};

export const formattedDateAndTime = (props) => {
  return props && moment(props).format('Do MMM YYYY, [at] h:mm a');
};

export const formattedDate = (props) => {
  return props && moment(props).format('Do MMM YYYY');
};

export const formattedDatewithFormat = (props, format) => {
  return props && moment(props).format(format);
};

export const getCityCoordinates = async (cityName, stateName) => {
  const apiKey = Config.GOOGLE_MAPS_API_KEY;

  const url = `${Config.googleGeocodingAPI}address=${cityName},${stateName}&key=${apiKey}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    if (data.results && data.results.length > 0) {
      const { lat, lng } = data.results[0].geometry.location;
      return { lat, lng };
    }
  } catch (error) {
    console.error('Error fetching coordinates:', error);
  }
  return null;
};

export const getCityFromCoordinates = async (lat, lng) => {
  const apiKey = Config.GOOGLE_MAPS_API_KEY;
  const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${apiKey}`;

  try {
    const response = await axios.get(url);
    const results = response.data.results;

    if (results.length > 0) {
      let city = '';
      let state = '';

      results[0].address_components.forEach((component) => {
        if (component.types.includes('locality')) {
          city = component.long_name;
        }
        if (component.types.includes('administrative_area_level_1')) {
          state = component.long_name;
        }
      });
      console.log(city, results[0].address_components);
      return { city, state, address: results[0].address_components };
    }
  } catch (error) {
    console.error('Error fetching city from coordinates:', error);
  }

  return null;
};

export const useQuery = (id) => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const bookingId = query.get(id);
  return bookingId;
};

export const handleShare = async () => {
  if (navigator.share) {
    try {
      await navigator.share({
        title: 'Share Report',
        text: 'Check out this report!',
        url: window.location.href // Or any URL you want to share
      });
      console.log('Report shared successfully');
    } catch (error) {
      console.error('Error sharing the report:', error);
    }
  } else {
  }
};

export const getLabTimings = () => {
  const branchTiming = [
    {
      day: 'Mon',
      is_available: true,
      on_timing: [
        {
          start: '10:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Tue',
      is_available: true,
      on_timing: [
        {
          start: '10:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Wed',
      is_available: true,
      on_timing: [
        {
          start: '10:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Thu',
      is_available: true,
      on_timing: [
        {
          start: '11:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Fri',
      is_available: true,
      on_timing: [
        {
          start: '10:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Sat',
      is_available: true,
      on_timing: [
        {
          start: '10:00',
          end: '20:00'
        }
      ]
    },
    {
      day: 'Sun',
      is_available: true,
      on_timing: []
    }
  ];
  const dayMapping = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const currentDay = dayMapping[new Date().getDay()];

  let minStartTime = '23:59';
  let maxEndTime = '00:00';
  let isAvailableToday = false;

  branchTiming.forEach((day) => {
    if (day.is_available && day.day === currentDay) {
      day.on_timing.forEach((timing) => {
        if (timing && timing.start && timing.end) {
          if (timing.start < minStartTime) {
            minStartTime = timing.start;
          }
          if (timing.end > maxEndTime) {
            maxEndTime = timing.end;
          }
        }
      });
      if (
        day.on_timing.some((timing) => timing && timing.start && timing.end)
      ) {
        isAvailableToday = true;
      }
    }
  });

  const getCurrentTime = () => {
    const date = new Date();
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  const isCurrentTimeInRange = (startTime, endTime) => {
    const currentTime = getCurrentTime();
    return currentTime >= startTime && currentTime <= endTime;
  };

  const combinedTiming = {
    day: 'Mon - Sun',
    is_available:
      isAvailableToday && isCurrentTimeInRange(minStartTime, maxEndTime)
        ? 'Open'
        : 'Close',
    status: isAvailableToday && isCurrentTimeInRange(minStartTime, maxEndTime),
    start: minStartTime,
    end: maxEndTime
  };

  let modifiedArr = [combinedTiming];
  console.log(modifiedArr);
  return modifiedArr;
};

export const getFormattedDays = (bookingsString) => {
  const allDays = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN'];

  // Helper function to convert uppercase day to Camel Case (capitalize the first letter)
  const toCamelCase = (day) => day.charAt(0) + day.slice(1).toLowerCase();

  // Split the bookings string and trim any extra spaces
  const bookingsArray = bookingsString?.split(',')?.map((day) => day.trim());

  // Check if all days are booked
  const isAllDays = allDays.every((day) => bookingsArray?.includes(day));

  // If all days are booked, return "All Days"
  if (isAllDays) {
    return 'All Days';
  }

  // Sort the bookingsArray to match the order of allDays
  const sortedBookings = bookingsArray?.sort(
    (a, b) => allDays.indexOf(a) - allDays.indexOf(b)
  );

  // Convert sorted bookings to Camel Case and join with commas
  const formattedDays = sortedBookings?.map(toCamelCase).join(', ');

  return formattedDays || '-'; // Handle case where there are no bookings
};

export const slugify = (text) => {
  if (!text) return '';

  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/&/g, '-and-')
    .replace(/[\s\W-]+/g, '-');
};

export const getStepClass = (step) => {
  switch (step) {
    case Config.stepIndices.myCart:
      return 'booking-seo-cart';
    case Config.stepIndices.chooseAddress:
      return 'booking-seo-address';
    case Config.stepIndices.chooseDateTimeSlot:
      return 'booking-seo-slots';
    case Config.stepIndices.reviewOrder:
      return 'booking-seo-review';
    case Config.stepIndices.choosePatient:
    default:
      return 'booking-sco-patient';
  }
};
